import { FileCheck2 } from 'lucide-react';

export const NoteAllocationPicker = ({ notes, allocations, onChange, documentBalance, label }) => {
  const selectedTotal = Object.values(allocations).reduce((sum, amount) => sum + (parseFloat(amount) || 0), 0);

  const toggleNote = (note) => {
    if (allocations[note.id] !== undefined) {
      const next = { ...allocations };
      delete next[note.id];
      onChange(next);
      return;
    }
    const remainingDocumentBalance = Math.max(0, documentBalance - selectedTotal);
    onChange({
      ...allocations,
      [note.id]: Math.min(note.available_amount || 0, remainingDocumentBalance),
    });
  };

  return (
    <div className="border border-amber-200 bg-amber-50/50 rounded-sm p-4" data-testid={`${label.toLowerCase().replace(/\s+/g, '-')}-picker`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <FileCheck2 className="h-4 w-4 text-amber-700" />
          <span className="text-sm font-semibold text-slate-700">Apply Available {label}</span>
        </div>
        <span className="text-xs font-medium text-amber-700">Selected: ₹{selectedTotal.toLocaleString('en-IN')}</span>
      </div>
      {!notes.length ? (
        <p className="text-xs text-slate-500">No available {label.toLowerCase()} balance exists for the selected party and company.</p>
      ) : (
        <div className="space-y-2 max-h-56 overflow-y-auto">
          {notes.map(note => {
            const selected = allocations[note.id] !== undefined;
            return (
              <div key={note.id} className="grid grid-cols-[auto_1fr_120px] gap-3 items-center bg-white border border-slate-200 px-3 py-2">
                <input type="checkbox" checked={selected} onChange={() => toggleNote(note)}
                  data-testid={`allocate-note-${note.id}`} className="h-4 w-4 text-orange-500 border-slate-300 rounded" />
                <div className="min-w-0">
                  <div className="text-sm font-medium text-slate-800 truncate">{note.return_number || label}</div>
                  <div className="text-xs text-slate-500">
                    {note.date || 'No date'} · Available ₹{Number(note.available_amount || 0).toLocaleString('en-IN')}
                    {Number(note.allocated_amount || 0) > 0 && ` · Used ₹${Number(note.allocated_amount).toLocaleString('en-IN')}`}
                  </div>
                </div>
                <input type="number" min="0" step="0.01"
                  max={Math.min(note.available_amount || 0, documentBalance)}
                  disabled={!selected}
                  value={selected ? allocations[note.id] : ''}
                  onChange={event => onChange({ ...allocations, [note.id]: event.target.value })}
                  aria-label={`Allocation amount for ${note.return_number || note.id}`}
                  className="w-full px-2 py-1.5 border border-slate-200 rounded-sm text-sm text-right disabled:bg-slate-100" />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
